<script setup lang="ts">
import { isExpand } from "@/views/Home/useData/useHomePage";
import UserMenu from "@/views/Home/components/UserMenu.vue";
import { openLoginDialog } from "@/components/Dialogues/useData/login";
import { ref } from "vue";
import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";

const { isLogin, userInfo } = storeToRefs(publicStore());
</script>

<template>
  <el-popover
    v-if="isLogin"
    placement="top"
    :width="200"
    trigger="click"
    :show-arrow="false"
    :style="{ '--el-popover-border-radius': 14 }"
  >
    <template #reference>
      <div class="bar" :class="{ close: !isExpand }">
        <div class="icon">
          <el-image
            v-if="userInfo.avatar"
            style="width: 34px; height: 34px"
            :src="userInfo.avatar"
            fit="cover"
          />
          <el-icon v-else :size="26"><UserFilled /></el-icon>
        </div>
        <div class="user-info" v-if="isExpand">个人信息</div>
      </div>
    </template>
    <UserMenu />
  </el-popover>
  <div v-else>
    <div class="bar" :class="{ close: !isExpand }" @click="openLoginDialog">
      <div class="icon">
        <el-icon :size="26"><UserFilled /></el-icon>
      </div>
      <div class="user-info" v-if="isExpand">点击登录</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.bar {
  width: 100%;
  min-height: 48px;
  padding: 8px 16px;

  display: flex;
  cursor: pointer;

  align-items: center;
  justify-content: space-between;
  gap: 10px;

  &:hover {
    background-color: #eee;
  }

  .icon {
    cursor: pointer;
    width: 34px;
    height: 34px;
    border-radius: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #dddddd;
    overflow: hidden;
  }

  .user-info {
    font-size: 14px;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.close {
  padding: 0;
  justify-content: center;
}
</style>
